import { Select, styled, Theme } from '@mui/material';
import { CoreDialog, CoreDialogTitle } from '@youscience/core';

export const sxStyles = {
  loaderWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '2.75rem',
  },

  coreRadioButton: {
    marginRight: '2rem',
  },
  content: {
    margin: '0 auto',
    padding: '1rem 5rem 2.5rem',
    paddingTop: '1rem !important',
  },
  titles: {
    textAlign: 'center',

    '& > p:last-of-type': {
      margin: '1rem 0 ',
    },
  },
  formWrap: {
    padding: '0 1.75rem',
  },
  datePicker: {
    '& label.MuiFormLabel-root': {
      top: '-5px',
    },

    ' & .MuiInputBase-input': {
      padding: '.54rem',
    },

    ' & .MuiFormControl-root': {
      height: 'unset',
    },
  },
};

export const StyledDialog = styled(CoreDialog)(() => ({
  '.MuiPaper-root': {
    maxWidth: '720px',
    width: '100%',
    borderRadius: '12px',
  },
}));

export const StyledDialogFormControls = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',

  '& > div:first-of-type': {
    width: 'auto',
  },
}));

export const StyledDialogTitle = styled(CoreDialogTitle)(({ theme }) => ({
  ...theme.typography.h4,
  maxWidth: '540px',
  margin: '0 auto',
  padding: '2.5rem 1.5rem 1rem',
  textAlign: 'center',
}));
